import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-long-arrow",
  "use": "icon-long-arrow-usage",
  "viewBox": "0 0 12.912 40.914",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12.912 40.914\" fill-rule=\"evenodd\" id=\"icon-long-arrow\"><path fill=\"#e3ad78\" fill-rule=\"nonzero\" d=\"M0 34.458l6.456 6.456 6.456-6.456-1.94-1.94-3.145 3.145V0H5.084v35.663l-3.145-3.145z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol